import React from 'react'
import { TooltipInfo } from '../TooltipInfo'

interface HighValueProductLabelProps {
  isHighValueProduct: boolean
  className?: string
}

export const HighValueProductLabel: React.FC<HighValueProductLabelProps> = ({
  isHighValueProduct,
  className,
}) => {
  if (!isHighValueProduct) return null
  return (
    <TooltipInfo
      valueKey='highvalue-product-label'
      content='🌟'
      tooltipText='High Value Product'
      showIcon={false}
      enforceMaxWidth={false}
      className={className}
    />
  )
}
